import {useContext} from 'react'
import {INavStateContext, IUrlParams, NavStateContext} from './context'

export function useNavState<
  TState extends {[key: string]: any} = {[key: string]: any},
  TArgs extends IUrlParams = IUrlParams,
>(): INavStateContext<TState, TArgs> {
  const ctx = useContext(NavStateContext) as any as INavStateContext<TState, TArgs>
  return ctx
}
